import { InstanceScreen } from 'component/navigation/instance';

export default function AdminVideoVotingListScreen() {
    return <InstanceScreen screenKey='videovotinglist' />;
}
